import React from 'react';
import { Link } from 'react-router-dom';

import type { Machine } from '@/lib/types';

export function MachineCard({ machine }: { machine: Machine }): React.ReactElement {
  return (
    <Link
      to={`/m/${machine.public_id}`}
      className="themed-card p-4 flex flex-col gap-2 hover:no-underline"
      style={{ color: 'var(--text-primary)' }}
    >
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold">{machine.name}</h3>
        {machine.owner && (
          <span className="text-xs" style={{ color: 'var(--text-secondary)' }}>
            @{machine.owner.username}
          </span>
        )}
      </div>
      {machine.short_description && (
        <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>
          {machine.short_description}
        </p>
      )}
      {machine.tags.length > 0 && (
        <div className="flex flex-wrap gap-1 mt-1">
          {machine.tags.map((tag) => (
            <span
              key={tag}
              className="text-xs px-2 py-0.5 rounded-full"
              style={{ backgroundColor: 'var(--bg-secondary)', color: 'var(--text-secondary)' }}
            >
              {tag}
            </span>
          ))}
        </div>
      )}
    </Link>
  );
}
